import { render } from "./HelpArea.vue?vue&type=template&id=0372c0f0"
import script from "./HelpArea.vue?vue&type=script&lang=js"
export * from "./HelpArea.vue?vue&type=script&lang=js"

import exportComponent from "/Users/william/Documents/beadographer3/bead3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__